
import React from 'react';
import { useLanguage } from '../lib/LanguageContext';
import { Shield, Users, Clock, MapPin } from 'lucide-react';

export default function About() {
  const { t, lang } = useLanguage();
  const data = t.sections.about;

  return (
    <div className="bg-white">
      <div className="relative bg-slate-950 py-16 md:py-24 lg:py-40 text-white overflow-hidden">
        {/* Background Image with Overlay */}
        <div className="absolute inset-0 z-0">
          <img 
            src="/images/blacksmith-welding-focus.jpg" 
            alt="" 
            className="w-full h-full object-cover opacity-30 brightness-50"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-950/60 to-transparent" />
          <div className="absolute inset-0 bg-gradient-to-r from-slate-950/80 via-transparent to-transparent" />
        </div>

        <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="max-w-3xl">
            <h1 className="text-4xl md:text-6xl font-extrabold mb-6 tracking-tight border-l-4 border-[#f59c01] pl-4 inline-block">
              {t.ui.aboutUs}
            </h1>
            <p className="text-xl md:text-2xl text-slate-300 leading-relaxed">
              {data.title}
            </p>
          </div>
        </div>
      </div>

      <section className="py-12 md:py-16 lg:py-24">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col lg:flex-row gap-16 items-center mb-12 lg:mb-24">
            <div className="lg:w-1/2">
              <h2 className="text-2xl md:text-3xl font-bold text-slate-900 mb-6 border-l-4 border-[#f59c01] pl-4 inline-block">
                {t.ui.solidPartner}
              </h2>
              <p className="text-lg text-slate-600 leading-relaxed mb-6">
                {data.content}
              </p>
              <p className="text-lg text-slate-600 leading-relaxed mb-8">
                {t.ui.aboutText}
              </p>
              <div className="grid grid-cols-2 gap-6">
                <div className="flex items-center space-x-3">
                  <Shield className="h-6 w-6 text-[#f59c01]" />
                  <span className="font-bold text-slate-900">{t.ui.quality}</span>
                </div>
                <div className="flex items-center space-x-3">
                  <Users className="h-6 w-6 text-[#f59c01]" />
                  <span className="font-bold text-slate-900">{t.ui.personal}</span>
                </div>
                <div className="flex items-center space-x-3">
                  <Clock className="h-6 w-6 text-[#f59c01]" />
                  <span className="font-bold text-slate-900">{t.ui.flexible}</span>
                </div>
                <div className="flex items-center space-x-3">
                  <MapPin className="h-6 w-6 text-[#f59c01]" />
                  <span className="font-bold text-slate-900">{t.ui.local}</span>
                </div>
              </div>
            </div>
            <div className="lg:w-1/2">
               <div className="relative">
                <div className="absolute -inset-4 bg-slate-100 rounded-2xl -z-10" />
                <img 
                  src="/images/pure-blacksmith-anvil.jpg" 
                  alt="Workshop" 
                  className="rounded-2xl shadow-xl w-full aspect-[21/9] lg:aspect-[4/3] object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
}
